
define('text!modules/ui/directives/fancy-loader/template.html',[],function () { return '<div class=c-fancyLoader><div class=c-fancyLoader--text ng-if=hasLoadingText translate=SHARED.LIST.LOADING></div><div class=c-fancyLoader--wrap><div></div><div></div><div></div><div></div><div></div></div></div>';});

